<template>
  <div class="personal-info-editor">
    <section class="info-section">
      <div class="info-item">
        <div class="info-type"><span>真实姓名</span></div>
        <div class="info-content disabled"><span class="disabled-info">{{realName}}</span></div>
      </div>
      <div class="info-item">
        <div class="info-type"><span>性别</span></div>
        <div class="info-content disabled"><span class="disabled-info">{{gender | genderFilter}}</span></div>
      </div>
      <div class="info-item">
        <div class="info-type"><span>手机号</span></div>
        <div class="info-content disabled"><span class="disabled-info">{{phone}}</span></div>
      </div>
      <div class="info-item">
        <div class="info-type"><span>身份证号</span></div>
        <div class="info-content disabled">
          <input type="text" class="form-text" placeholder="请输入" v-model="IDNumber">
        </div>
        <div class="form-error" v-if="IDNumberError"><van-icon name="fail" />{{IDNumberErrorMsg}}</div>
      </div>
      <div class="info-item click" @click="showBornPicker">
        <div class="info-type"><span>出生年月</span></div>
        <div class="info-content">
          <div class="picker-tips" v-if="!birthday">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{birthday | parseDateToMonth}}</div>
        </div>
      </div>
      <div class="info-item">
        <div class="info-type"><span>身高 (cm)</span></div>
        <div class="info-content">
          <number-input class="number-input" placeholder="请输入" v-model="height" :max="300" />
        </div>
      </div>
      <div class="info-item">
        <div class="info-type"><span>体重 (kg)</span></div>
        <div class="info-content">
          <number-input class="number-input" placeholder="请输入" v-model="weight" />
        </div>
      </div>
      <div class="info-item">
        <div class="info-type"><span>BMI</span></div>
        <div class="info-content disabled"><span class="disabled-info">{{bmi}}</span></div>
      </div>
      <div class="info-item click" :class="{'editable-item': allergy == '有'}" @click="allergyPickerShow = true">
        <div class="info-type"><span class="required">过敏史</span></div>
        <div class="info-content">
          <div class="picker-tips" v-if="!allergy">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{allergy}}</div>
        </div>
      </div>
      <div class="allergy-textarea" v-if="allergy == '有'">
        <textarea class="form-textarea" placeholder="如有过敏史请说明" v-ios-bug-fixed v-model="allergyText" maxlength="100"></textarea>
        <span class="textarea-limit">{{allergyText.length}}/100</span>
      </div>
      <div class="info-item click" @click="marriagePickerShow = true">
        <div class="info-type"><span>婚况</span></div>
        <div class="info-content">
          <div class="picker-tips" v-if="!marriage">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{marriage | marriageFilter}}</div>
        </div>
      </div>
      <div class="info-item click" @click="parentalPickerShow = true">
        <div class="info-type"><span>是否生育</span></div>
        <div class="info-content">
          <div class="picker-tips" v-if="!parental">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{parental | parentalFilter}}</div>
        </div>
      </div>
      <div class="info-item click" @click="nationalityPickerShow = true">
        <div class="info-type"><span>民族</span></div>
        <div class="info-content">
          <div class="picker-tips" v-if="!nationality">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{nationality}}</div>
        </div>
      </div>
      <div class="info-item click" @click="jobPickerShow = true">
        <div class="info-type"><span>职业</span></div>
        <div class="info-content">
          <div class="picker-tips" v-if="!job">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{job}}</div>
        </div>
      </div>
    </section>
    <section class="info-section">
      <div class="info-item click" @click="smokePickerShow = true">
        <div class="info-type"><span>是否吸烟</span></div>
        <div class="info-content">
          <div class="picker-tips" v-if="!smoke">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{smoke}}</div>
        </div>
      </div>
      <div class="info-item click" @click="drinkPickerShow = true">
        <div class="info-type"><span>是否饮酒</span></div>
        <div class="info-content">
          <div class="picker-tips" v-if="!drink">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{drink}}</div>
        </div>
      </div>
      <div class="info-item vertical">
        <div class="info-type"><span>是否有家族遗传病史</span></div>
        <div class="info-content">
          <textarea class="form-textarea low-height" v-model="genetic" v-ios-bug-fixed placeholder="是否有家族遗传病史，如有请说明" maxlength="100"></textarea>
          <span class="textarea-limit">{{genetic.length}}/100</span>
        </div>
      </div>
      <div class="info-item vertical">
        <div class="info-type"><span>既往重大疾病史</span></div>
        <div class="info-content">
          <textarea class="form-textarea low-height" v-model="seriousIllness" v-ios-bug-fixed placeholder="是否有高血压、糖尿病、高脂血症、冠心病，肝炎、结核病等传染病史，外伤史、手术史等" maxlength="100"></textarea>
          <span class="textarea-limit">{{seriousIllness.length}}/100</span>
        </div>
      </div>
    </section>
    <div class="save-info"><button class="save-button" :disabled="saving" @click="saveInfo">保存修改</button></div>

    <!-- 弹出层 -->
    <!-- 出生年月选择 -->
    <van-popup v-model="bornPickerShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        type="year-month"
        v-model="birthday"
        :formatter="formatter"
        :max-date="maxDate"
        :min-date="minDate"
        @cancel="bornPickerShow = false"
        @confirm="confirmBirthday"
      />
    </van-popup>
    <!-- 过敏史选择 -->
    <van-popup v-model="allergyPickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="allergyOptions"
        @cancel="allergyPickerShow = false"
        @confirm="confirmAllergy"
      />
    </van-popup>
    <!-- 婚况选择 -->
    <van-popup v-model="marriagePickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="marriageOptions"
        value-key="label"
        @cancel="marriagePickerShow = false"
        @confirm="confirmMarriage"
      />
    </van-popup>
    <!-- 生育状况选择 -->
    <van-popup v-model="parentalPickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="parentalOptions"
        value-key="label"
        @cancel="parentalPickerShow = false"
        @confirm="confirmParental"
      />
    </van-popup>
    <!-- 民族选择 -->
    <van-popup v-model="nationalityPickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="nationalityOptions"
        value-key="name"
        @cancel="nationalityPickerShow = false"
        @confirm="confirmNationality"
      />
    </van-popup>
    <!-- 职业选择 -->
    <van-popup v-model="jobPickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="jobOptions"
        @cancel="jobPickerShow = false"
        @confirm="confirmJob"
      />
    </van-popup>
    <!-- 吸烟选择 -->
    <van-popup v-model="smokePickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="smokeOptions"
        value-key="label"
        @cancel="smokePickerShow = false"
        @confirm="confirmSmoke"
      />
    </van-popup>
    <!-- 饮酒选择 -->
    <van-popup v-model="drinkPickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="drinkOptions"
        value-key="label"
        @cancel="drinkPickerShow = false"
        @confirm="confirmDrink"
      />
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .personal-info-editor{
    padding-top: 12px;
    min-height: 100vh;
    background: #F7F7F7;
    .info-section{
      padding: 20px 0 12px;
      margin-bottom: 12px;
      background: #FFF;
      .info-item{
        position: relative;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #FFF;
        height: 40px;
        margin-bottom: 16px;
        transition: all .1s;
        &.click{
          cursor: pointer;
          &:active{
            background: #F9F9F9;
          }
        }
        &.editable-item{
          margin-bottom: 0;
        }
        &.vertical{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          height: auto;
          padding-top: 16px;
          .info-type{
            line-height: 16px;
          }
          .info-content{
            position: relative;
            width: 100%;
            margin-top: 16px;
            .form-textarea{
              border: 1px solid #F7F7F7;
              background: #F7F7F7;
              resize: none;
              padding: 12px;
              font-size: 14px;
              line-height: 20px;
              color: #666;
              width: 100%;
              height: 96px;
              &::-webkit-input-placeholder{
                color: #999;
              }
            }
            .textarea-limit{
              position: absolute;
              right: 8px;
              bottom: 8px;
              font-size: 12px;
              color: #999;
            }
          }
        }
        .info-type{
          font-size: 16px;
          color: #666;
          font-weight: bold;
          flex-shrink: 0;
          .required{
            position: relative;
            &::after{
              content: '*';
              position: absolute;
              left: 100%;
              top: 0;
              margin-left: 2px;
              font-size: 16px;
              color: @error;
            }
          }
        }
        .info-content{
          color: #666;
          font-size: 16px;
          flex: 1;
          text-align: right;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          &.disabled{
            color: #999;
          }
          .picker-tips{
            font-size: 16px;
            line-height: 40px;
            color: #999;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            svg{
              color: #CCC;
              position: relative;
              // top: 2px;
              font-size: 14px;
              margin-left: 4px;
            }
          }
          .picker-value{
            max-width: 90%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .number-input{
            width: 200px;
            border: 0;
            text-align: right;
            font-size: 16px;
            line-height: 40px;
            color: #666;
            background: transparent;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
          .form-text{
            text-align: right;
            font-size: 16px;
            line-height: 40px;
            color: #666;
            background: transparent;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
        }
        .form-error{
          position: absolute;
          right: 16px;
          top: 100%;
          font-size: 12px;
          color: @error;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .van-icon{
            position: relative;
            top: 1px;
            width: 12px;
            height: 12px;
            background: @error;
            color: #FFF;
            border-radius: 50%;
            margin-right: 4px;
          }
        }
      }
    }
    .allergy-textarea{
      position: relative;
      padding: 0 16px;
      width: 100%;
      margin-bottom: 16px;
      .form-textarea{
        border: 1px solid #F7F7F7;
        background: #F7F7F7;
        resize: none;
        padding: 12px;
        font-size: 14px;
        line-height: 20px;
        color: #666;
        width: 100%;
        height: 96px;
        &::-webkit-input-placeholder{
          color: #999;
        }
      }
      .textarea-limit{
        position: absolute;
        right: 24px;
        bottom: 8px;
        font-size: 12px;
        color: #999;
      }
    }
    .save-info{
      padding: 12px 16px;
      .save-button{
        @button-base();
        width: 100%;
        height: 40px;
      }
    }
  }
</style>

<script type="text/javascript">
  import numberInput from '@/components/Common/numberInput'
  import nationalityOptions from '@/config/nationalityOptions'
  export default {
    data() {
      return {
        saving: false,
        realName: '',
        gender: '',
        // 身份证号
        IDNumber: '',
        IDNumberError: false,
        IDNumberErrorMsg: '请输入身份证号',
        phone: '',
        birthday: '',
        bornPickerShow: false,
        // 年月最大值
        maxDate: new Date(),
        minDate: new Date(1900, 1, 1),
        height: null,
        weight: null,
        // 过敏史
        allergy: '',
        allergyText: '',
        allergyPickerShow: false,
        allergyOptions: ['有', '否认', '不确定'],
        // 婚况
        marriage: '',
        marriagePickerShow: false,
        marriageOptions: [{label: '已婚', value: 1}, {label: '未婚', value: 2}],
        // 生育
        parental: '',
        parentalPickerShow: false,
        parentalOptions: [{label: '已育', value: 1}, {label: '未育', value: 2}],
        // 民族
        nationality: '',
        nationalityPickerShow: false,
        nationalityOptions,
        job: '',
        jobPickerShow: false,
        jobOptions: ['国家机关、党群组织、企业、事业单位负责人', '专业技术人员', '办事人员和有关人员', '商业、服务业人员', '农、林、牧、渔、水利业生产人员', '生产、运输设备操作人员及有关人员', '军人', '其他从业人员'],
        // 吸烟
        smoke: '',
        smokePickerShow: false,
        smokeOptions: ['是', '否'],
        // 饮酒
        drink: '',
        drinkPickerShow: false,
        drinkOptions: ['是', '否'],
        // 遗传病
        genetic: '',
        // 重大病史
        seriousIllness: '',
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      // BMI计算
      bmi() {
        if(+this.height && +this.weight) {
          let heightM = this.height /100;
          let bmiValue = this.weight / (heightM * heightM)
          return bmiValue.toFixed(1);
        }
        return '0.0';
      }
    },
    watch: {
      IDNumber(val) {
        if($.trim(val) == '') {
          this.IDNumberError = true
          this.IDNumberErrorMsg = '请输入身份证号'
        }else if(!/^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$/.test($.trim(val))) {
          this.IDNumberError = true
          this.IDNumberErrorMsg = '请输入正确的身份证号'
        }else {
          this.IDNumberError = false
        }
      },
    },
    components: {
      numberInput
    },
    created() {
      this.$root.post('/getPatientDetail', {
        pat_id: this.userInfo.user_id
      }).then(data => {
        // 数据回显
        this.realName = data.username || '';
        this.gender = data.gender || '';
        this.IDNumber = data.id_number || '';
        this.phone = data.mobile || '';
        this.birthday = moment(data.birthday, 'YYYY/M') || '';
        this.height = parseFloat(data.stature) || null;
        this.weight = parseFloat(data.weight) || null;
        if(data.allergy) {
          if(data.allergy == '否认' || data.allergy == '不确定' ) {
            this.allergy = data.allergy;
          }else {
            this.allergy = '有';
            this.allergyText = data.allergy;
          }
        }
        if(data.is_married != 3) {
          this.marriage = data.is_married
        }
        if(data.is_childbed != 3) {
          this.parental = data.is_childbed
        }
        this.nationality = data.nation || '';
        this.job = data.job || '';
        if(data.is_smoke != 3) {
          this.smoke = data.is_smoke == 1 ? '是' : '否';
        }
        if(data.is_drink != 3) {
          this.drink = data.is_drink == 1 ? '是' : '否';
        }
        this.genetic = data.gen_disease || '';
        this.seriousIllness = data.ser_disease || '';
      })
    },
    methods: {
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        }
        return value;
      },
      showBornPicker() {
        this.birthday = new Date(this.birthday);
        this.bornPickerShow = true
      },
      confirmBirthday(value) {
        this.birthday = value;
        this.bornPickerShow = false;
      },
      confirmAllergy(value) {
        this.allergy = value;
        this.allergyPickerShow = false;
      },
      confirmMarriage(value) {
        this.marriage = value.value;
        this.marriagePickerShow = false;
      },
      confirmParental(value) {
        this.parental = value.value;
        this.parentalPickerShow = false;
      },
      confirmNationality(value) {
        this.nationality = value.name;
        this.nationalityPickerShow = false;
      },
      confirmJob(value) {
        this.job = value;
        this.jobPickerShow = false;
      },
      confirmSmoke(value) {
        this.smoke = value;
        this.smokePickerShow = false;
      },
      confirmDrink(value) {
        this.drink = value;
        this.drinkPickerShow = false;
      },
      // 保存
      saveInfo() {
        // if(!this.height) {
        //   this.$notify('请填写身高');
        //   return;
        // }
        // if(!this.weight) {
        //   this.$notify('请填写体重');
        //   return;
        // }
        if(!this.allergy) {
          this.$notify('请选择过敏史');
          return;
        }
        if(this.allergy == '有' && !this.allergyText) {
          this.$notify('请填写过敏史说明');
          return;
        }
        this.saving = true;
        let postData = {
          user_id: this.userInfo.user_id,
          username: this.realName,
          gender: this.gender,
          id_number: this.IDNumber,
          birthday: moment(this.birthday).format('YYYY/M'),
          stature: this.height,
          weight: this.weight,
          allergy: (this.allergy == '否认' || this.allergy == '不确定') ? this.allergy : this.allergyText,
          is_married: this.marriage ? this.marriage : 3,
          is_childbed: this.parental ? this.parental : 3,
          nation: this.nationality,
          job: this.job,
          is_smoke: this.smoke ? (this.smoke == '是' ? 1 : 2) : 3,
          is_drink: this.drink ? (this.drink == '是' ? 1 : 2) : 3,
          gen_disease: this.genetic,
          ser_disease: this.seriousIllness,
        }
        this.$root.post('/updatePatientInfo', postData).then(data => {
          this.saving = false;
          if(data.status == 1) {
            this.$notify({
              background: '#00848A',
              message: '保存成功'
            });
            this.$router.go(-1);
          }else {
            this.$notify(data.msg);
          }
        })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/MedicalRecord/editPersonalInfo.vue